const KEY_DESTINATION_URL = "destinationUrl";
const KEY_OPEN_DETAILS_DIALOG = "openDetailsDialog";
const KEY_OPEN_MANAGE_CONTACT_DIALOG = "openManageContactDialog";
const KEY_SKIP_ACCOUNTS = "skipAccounts";
const KEY_OPEN_CANCEL_PLAN_DIALOG = "openCancelPlanDialog";
const KEY_OPEN_DETAILS_DIALOG_DASHBOARD = "openDetailsDialogDashboard";
const KEY_OPEN_DETAILS_DIALOG_ACCOUNT_ID = "openDetailsDialogAccountId";

const clearNoLoginDialogFlags = () => {
  sessionStorage.removeItem(KEY_OPEN_DETAILS_DIALOG);
  sessionStorage.removeItem(KEY_OPEN_DETAILS_DIALOG_ACCOUNT_ID);
  sessionStorage.removeItem(KEY_OPEN_MANAGE_CONTACT_DIALOG);
  sessionStorage.removeItem(KEY_OPEN_CANCEL_PLAN_DIALOG);
  sessionStorage.removeItem(KEY_OPEN_DETAILS_DIALOG_DASHBOARD);
};

export {
  KEY_DESTINATION_URL,
  KEY_OPEN_DETAILS_DIALOG,
  KEY_OPEN_MANAGE_CONTACT_DIALOG,
  KEY_SKIP_ACCOUNTS,
  KEY_OPEN_CANCEL_PLAN_DIALOG,
  KEY_OPEN_DETAILS_DIALOG_DASHBOARD,
  KEY_OPEN_DETAILS_DIALOG_ACCOUNT_ID,
  clearNoLoginDialogFlags,
};
